import React, { useState } from 'react';

const Profile = () => {
  const [activeTab, setActiveTab] = useState('about');
  const [aboutForm, setAboutForm] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    whatsapp: '',
    email: '',
  });
  const [addressForm, setAddressForm] = useState({
    address: '',
    landmark: '',
    city: '',
    state: '',
    zip: '',
  });
  const [petForm, setPetForm] = useState({
    petName: '',
    petType: '',
    petBreed: '',
    gender: '',
    size: '',
    age: '',
    spayedNeutered: '',
  });
  const [errors, setErrors] = useState({});

  const tabs = [
    { id: 'about', label: 'About Me' },
    { id: 'address', label: 'My Address' },
    { id: 'pet', label: 'Add Pet' },
  ];

  const handleAboutChange = (e) => {
    setAboutForm({ ...aboutForm, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleAddressChange = (e) => {
    setAddressForm({ ...addressForm, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handlePetChange = (e) => {
    setPetForm({ ...petForm, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validatePetForm = () => {
    const newErrors = {};
    if (!petForm.petName) newErrors.petName = 'Pet Name is required';
    if (!petForm.petType) newErrors.petType = 'Pet Type is required';
    if (!petForm.petBreed) newErrors.petBreed = 'Pet Breed is required';
    if (!petForm.gender) newErrors.gender = 'Gender is required';
    if (!petForm.size) newErrors.size = 'Size is required';
    if (!petForm.age) newErrors.age = 'Age is required';
    if (!petForm.spayedNeutered) newErrors.spayedNeutered = 'Spayed/Neutered status is required';
    return newErrors;
  };

  const handleSave = (formType) => {
    if (formType === 'about') {
      
    } else if (formType === 'address') {
  
    } else if (formType === 'pet') {
      const newErrors = validatePetForm();
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        // alert('Please fill all required fields');
        return;
      }
    }
  };

  return (
    <div className="bg-[#FFF6F1] p-4 sm:p-6 lg:p-8">
      <h1 className="text-[#1B4582] text-2xl sm:text-3xl font-bold mb-6">Profile</h1>
      <div className="flex flex-col lg:flex-row gap-6">
        {/* Left Side: Tab Buttons */}
        <div className="w-full lg:w-1/4">
          <div className="flex flex-row lg:flex-col gap-2 sm:gap-3">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full text-left px-4 py-2.5 font-semibold rounded-md text-base sm:text-lg transition duration-150 ${
                  activeTab === tab.id
                    ? 'bg-[#1B4582] text-white shadow-md'
                    : 'bg-gray-200 text-[#1B4582] hover:bg-gray-300'
                }`}
                role="tab"
                aria-selected={activeTab === tab.id}
                aria-controls={`panel-${tab.id}`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Right Side: Form Content */}
        <div className="w-full lg:w-3/4 bg-white rounded-xl p-6 shadow-md">
          {/* About Me Form */}
          <div id="panel-about" role="tabpanel" className={activeTab === 'about' ? 'block' : 'hidden'}>
            <h2 className="bg-[#1B4582] text-white p-3 rounded-md text-xl sm:text-2xl font-semibold mb-4">About Me</h2>

            <div className="space-y-4">
              <div>
                <label htmlFor="firstName" className="block text-gray-700 font-medium">
                  First Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={aboutForm.firstName}
                  onChange={handleAboutChange}
                  placeholder="Enter First Name"
                  className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                    errors.firstName ? 'border-red-500' : 'border-[#dbdbe5]'
                  }`}
                />
                {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
              </div>
              <div>
                <label htmlFor="lastName" className="block text-gray-700 font-medium">
                  Last Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={aboutForm.lastName}
                  onChange={handleAboutChange}
                  placeholder="Enter Last Name"
                  className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                    errors.lastName ? 'border-red-500' : 'border-[#dbdbe5]'
                  }`}
                />
                {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
              </div>
              <div>
                <label htmlFor="phone" className="block text-gray-700 font-medium">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={aboutForm.phone}
                  onChange={handleAboutChange}
                  placeholder="Enter Phone Number"
                  className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                    errors.phone ? 'border-red-500' : 'border-[#dbdbe5]'
                  }`}
                />
                {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
              </div>
              <div>
                <label htmlFor="whatsapp" className="block text-gray-700 font-medium">
                  WhatsApp Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="whatsapp"
                  name="whatsapp"
                  value={aboutForm.whatsapp}
                  onChange={handleAboutChange}
                  placeholder="Enter WhatsApp Number"
                  className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                    errors.whatsapp ? 'border-red-500' : 'border-[#dbdbe5]'
                  }`}
                />
                {errors.whatsapp && <p className="text-red-500 text-sm mt-1">{errors.whatsapp}</p>}
              </div>
              <div>
                <label htmlFor="email" className="block text-gray-700 font-medium">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={aboutForm.email}
                  onChange={handleAboutChange}
                  placeholder="Enter Email"
                  className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                    errors.email ? 'border-red-500' : 'border-[#dbdbe5]'
                  }`}
                />
                {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
              </div>
              <button
                onClick={() => handleSave('about')}
                className="bg-[#FF6216] text-white px-6 py-2.5 font-semibold rounded-md hover:bg-[#e05514] transition duration-150"
              >
                Save
              </button>
            </div>
          </div>

          {/* My Address Form */}
          <div id="panel-address" role="tabpanel" className={activeTab === 'address' ? 'block' : 'hidden'}>
            <h2 className="bg-[#1B4582] text-white p-3 rounded-md text-xl sm:text-2xl font-semibold mb-4">My Address</h2>

            <div className="space-y-4">
              <div>
                <label htmlFor="address" className="block text-gray-700 font-medium">
                  Home Address <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={addressForm.address}
                  onChange={handleAddressChange}
                  placeholder="Enter Home Address"
                  className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                    errors.address ? 'border-red-500' : 'border-[#dbdbe5]'
                  }`}
                />
                {errors.address && <p className="text-red-500 text-sm mt-1">{errors.address}</p>}
              </div>
              <div>
                <label htmlFor="landmark" className="block text-gray-700 font-medium">
                  Landmark <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="landmark"
                  name="landmark"
                  value={addressForm.landmark}
                  onChange={handleAddressChange}
                  placeholder="Enter Landmark"
                  className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                    errors.landmark ? 'border-red-500' : 'border-[#dbdbe5]'
                  }`}
                />
                {errors.landmark && <p className="text-red-500 text-sm mt-1">{errors.landmark}</p>}
              </div>
              <div>
                <label htmlFor="city" className="block text-gray-700 font-medium">
                  City <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={addressForm.city}
                  onChange={handleAddressChange}
                  placeholder="Enter City"
                  className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                    errors.city ? 'border-red-500' : 'border-[#dbdbe5]'
                  }`}
                />
                {errors.city && <p className="text-red-500 text-sm mt-1">{errors.city}</p>}
              </div>
              <div>
                <label htmlFor="state" className="block text-gray-700 font-medium">
                  State <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="state"
                  name="state"
                  value={addressForm.state}
                  onChange={handleAddressChange}
                  placeholder="Enter State"
                  className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                    errors.state ? 'border-red-500' : 'border-[#dbdbe5]'
                  }`}
                />
                {errors.state && <p className="text-red-500 text-sm mt-1">{errors.state}</p>}
              </div>
              <div>
                <label htmlFor="zip" className="block text-gray-700 font-medium">
                  Pin Code <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="zip"
                  name="zip"
                  value={addressForm.zip}
                  onChange={handleAddressChange}
                  placeholder="Enter Pin Code"
                  className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                    errors.zip ? 'border-red-500' : 'border-[#dbdbe5]'
                  }`}
                />
                {errors.zip && <p className="text-red-500 text-sm mt-1">{errors.zip}</p>}
              </div>
              <button
                onClick={() => handleSave('address')}
                className="bg-[#FF6216] text-white px-6 py-2.5 font-semibold rounded-md hover:bg-[#e05514] transition duration-150"
              >
                Save
              </button>
            </div>
          </div>

          {/* Add Pet Form */}
          <div id="panel-pet" role="tabpanel" className={activeTab === 'pet' ? 'block' : 'hidden'}>
            <h2 className="bg-[#1B4582] text-white p-3 rounded-md text-xl sm:text-2xl font-semibold mb-4">Add Pet</h2>

            <div className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="petName" className="block text-gray-700 font-medium">
                    Pet Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="petName"
                    name="petName"
                    value={petForm.petName}
                    onChange={handlePetChange}
                    placeholder="Enter Pet Name"
                    className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                      errors.petName ? 'border-red-500' : 'border-[#dbdbe5]'
                    }`}
                  />
                  {errors.petName && <p className="text-red-500 text-sm mt-1">{errors.petName}</p>}
                </div>
                <div>
                  <p className="text-gray-700 font-medium mb-2">
                    Pet Type <span className="text-red-500">*</span>
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {['Dog', 'Cat'].map((type) => (
                      <button
                        key={type}
                        onClick={() => {
                          setPetForm({ ...petForm, petType: type.toLowerCase() });
                          setErrors({ ...errors, petType: '' });
                        }}
                        className={`px-4 py-2 rounded-full font-medium text-sm sm:text-base transition duration-150 ${
                          petForm.petType === type.toLowerCase()
                            ? 'bg-[#1B4582] text-white shadow-md'
                            : 'bg-gray-200 text-[#1B4582] hover:bg-gray-300'
                        }`}
                        role="radio"
                        aria-checked={petForm.petType === type.toLowerCase()}
                        aria-label={`Select ${type}`}
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                  {errors.petType && <p className="text-red-500 text-sm mt-1">{errors.petType}</p>}
                </div>
              </div>
              <div>
                <label htmlFor="petBreed" className="block text-gray-700 font-medium">
                  Pet Breed <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="petBreed"
                  name="petBreed"
                  value={petForm.petBreed}
                  onChange={handlePetChange}
                  placeholder="Enter Pet Breed"
                  className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1B4582] text-sm sm:text-base ${
                    errors.petBreed ? 'border-red-500' : 'border-[#dbdbe5]'
                  }`}
                />
                {errors.petBreed && <p className="text-red-500 text-sm mt-1">{errors.petBreed}</p>}
              </div>
              <div>
                <p className="text-gray-700 font-medium mb-2">
                  Gender <span className="text-red-500">*</span>
                </p>
                <div className="flex flex-wrap gap-2">
                  {['Male', 'Female'].map((gender) => (
                    <button
                      key={gender}
                      onClick={() => {
                        setPetForm({ ...petForm, gender: gender.toLowerCase() });
                        setErrors({ ...errors, gender: '' });
                      }}
                      className={`px-4 py-2 rounded-full font-medium text-sm sm:text-base transition duration-150 ${
                        petForm.gender === gender.toLowerCase()
                          ? 'bg-[#1B4582] text-white shadow-md'
                          : 'bg-gray-200 text-[#1B4582] hover:bg-gray-300'
                      }`}
                      role="radio"
                      aria-checked={petForm.gender === gender.toLowerCase()}
                      aria-label={`Select ${gender}`}
                    >
                      {gender}
                    </button>
                  ))}
                </div>
                {errors.gender && <p className="text-red-500 text-sm mt-1">{errors.gender}</p>}
              </div>
              <div>
                <p className="text-gray-700 font-medium mb-2">
                  How big is your pet? <span className="text-red-500">*</span>
                </p>
                <div className="flex flex-wrap gap-2">
                  {['Small', 'Medium', 'Large', 'Extra Large'].map((size) => (
                    <button
                      key={size}
                      onClick={() => {
                        setPetForm({ ...petForm, size: size.toLowerCase() });
                        setErrors({ ...errors, size: '' });
                      }}
                      className={`px-4 py-2 rounded-full font-medium text-sm sm:text-base transition duration-150 ${
                        petForm.size === size.toLowerCase()
                          ? 'bg-[#1B4582] text-white shadow-md'
                          : 'bg-gray-200 text-[#1B4582] hover:bg-gray-300'
                      }`}
                      role="radio"
                      aria-checked={petForm.size === size.toLowerCase()}
                      aria-label={`Select ${size}`}
                    >
                      {size}
                    </button>
                  ))}
                </div>
                {errors.size && <p className="text-red-500 text-sm mt-1">{errors.size}</p>}
              </div>
              <div>
                <p className="text-gray-700 font-medium mb-2">
                  How old is your pet? <span className="text-red-500">*</span>
                </p>
                <div className="flex flex-wrap gap-2">
                  {['Puppy', 'Adult', 'Senior'].map((age) => (
                    <button
                      key={age}
                      onClick={() => {
                        setPetForm({ ...petForm, age: age.toLowerCase() });
                        setErrors({ ...errors, age: '' });
                      }}
                      className={`px-4 py-2 rounded-full font-medium text-sm sm:text-base transition duration-150 ${
                        petForm.age === age.toLowerCase()
                          ? 'bg-[#1B4582] text-white shadow-md'
                          : 'bg-gray-200 text-[#1B4582] hover:bg-gray-300'
                      }`}
                      role="radio"
                      aria-checked={petForm.age === age.toLowerCase()}
                      aria-label={`Select ${age}`}
                    >
                      {age}
                    </button>
                  ))}
                </div>
                {errors.age && <p className="text-red-500 text-sm mt-1">{errors.age}</p>}
              </div>
              <div>
                <p className="text-gray-700 font-medium mb-2">
                  Has your pet been spayed or neutered? <span className="text-red-500">*</span>
                </p>
                <div className="flex flex-wrap gap-2">
                  {['Yes', 'No', 'Not Sure'].map((status) => (
                    <button
                      key={status}
                      onClick={() => {
                        setPetForm({ ...petForm, spayedNeutered: status.toLowerCase().replace(' ', '') });
                        setErrors({ ...errors, spayedNeutered: '' });
                      }}
                      className={`px-4 py-2 rounded-full font-medium text-sm sm:text-base transition duration-150 ${
                        petForm.spayedNeutered === status.toLowerCase().replace(' ', '')
                          ? 'bg-[#1B4582] text-white shadow-md'
                          : 'bg-gray-200 text-[#1B4582] hover:bg-gray-300'
                      }`}
                      role="radio"
                      aria-checked={petForm.spayedNeutered === status.toLowerCase().replace(' ', '')}
                      aria-label={`Select ${status}`}
                    >
                      {status}
                    </button>
                  ))}
                </div>
                {errors.spayedNeutered && <p className="text-red-500 text-sm mt-1">{errors.spayedNeutered}</p>}
              </div>
              <button
                onClick={() => handleSave('pet')}
                className="bg-[#FF6216] text-white px-6 py-2.5 font-semibold rounded-md hover:bg-[#e05514] transition duration-150"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
